const map = new Map();

const store = {
  getItem(k) {
    const key = `${k}`;
    if (!map.has(key)) return null;
    return map.get(key);
  },
  setItem(k, value) {
    map.set(`${k}`, value);
    return null;
  },
};

export default store;